import styled from '@emotion/styled';
import { font, mediaQueries, remCalc, palette, teaserHoverOff, teaserHoverOn, focuses, sizeMap } from '../../css';

const StyledContainer = styled('div')(() => ({
    position: 'relative',
    minHeight: remCalc(112),
    padding: 0,
    [mediaQueries.large]: {
        paddingBottom: '56.25%',
        minHeight: 'auto',
    },
}));

const StyledLink = styled('a')(() => ({
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    padding: remCalc(15),
    ...teaserHoverOff('bottom'),
    ':hover': teaserHoverOn('bottom', 3),
    ...focuses.rgaa(),
}));

const StyledBackground = styled('div')(() => ({
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
}));

const StyledLogo = styled('div')(() => ({
    display: 'flex',
    marginRight: remCalc(5),
    zIndex: 1,
    flexShrink: 0,
    [mediaQueries.large]: {
        marginLeft: remCalc(-10),
    },
}));

const StyledTitle = styled('h3')(() => ({
    margin: 0,
    color: palette('white'),
    zIndex: 1,
    fontFamily: font.family.header,
    fontSize: remCalc(sizeMap.m * 0.95),
    fontWeight: font.weight.medium,
    lineHeight: font.lineHeight.m,
    [mediaQueries.xlarge]: {
        fontSize: remCalc(sizeMap.m * 1.1),
        lineHeight: font.lineHeight.m,
    },
}));

export { StyledContainer, StyledLink, StyledBackground, StyledLogo, StyledTitle };
